__turbopack_context__.v({
  "checked": "RadioButton-module__EmlKBa__checked",
  "primary": "RadioButton-module__EmlKBa__primary",
  "radioButton": "RadioButton-module__EmlKBa__radioButton",
  "radioButtonLabel": "RadioButton-module__EmlKBa__radioButtonLabel",
  "secondary": "RadioButton-module__EmlKBa__secondary",
});
